const { createFeedSelectors } = require('client-v2/common/containers/feed/selectors')

module.exports = createFeedSelectors('featuredCollections')
